import environment from 'platform/utilities/environment';
import ClearLanding from './containers/ClearLanding';
import SignInApp from './containers/SignInApp';
import SignInWrapper from './components/SignInWrapper';
import MockAuth from './containers/MockAuth';
import PasskeyInterim from './containers/PasskeyInterim';
import { clearSigninGuard } from './containers/ClearSigninGuard';

const commonPaths = [
  {
    path: 'sign-in-to-vagov-with-clear',
    component: clearSigninGuard(ClearLanding),
  },
  {
    path: 'create-a-passkey',
    component: PasskeyInterim,
  },
];

const routes = {
  path: '/',
  component: SignInWrapper,
  indexRoute: { component: SignInApp },
  childRoutes:
    environment.isDev() || environment.isLocalhost()
      ? [
          {
            path: 'mocked-auth',
            component: MockAuth,
          },
          ...commonPaths,
        ]
      : commonPaths,
};

export default routes;
